<!-- Wheel of death loader -->
<div class="loading" *ngIf="loading"> 
  <div class="spinner-img">

    <img src="../../../../assets/images/CFO_symbol_white.png" alt="">

</div>

  <!-- <img src="assets/images/blue-loading-circle-icon-buffer-loader-or-vector-29007130.jpeg" alt="loader"> -->
</div>



 <!-- Inner loader html below -->
 <!-- <div class="spinner" *ngIf="loading">

  <div class="spinner-img">

      <img src="../../../../assets/images/CFO_symbol_white.png" alt="">

  </div>

</div> -->
